import { createFileRoute } from "@tanstack/react-router";
import AgentAuditPage from "@/pages/AgentAuditPage";

export const Route = createFileRoute("/_app/agent-audit")({
  component: AgentAuditPage,
});
